var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.49984 2.83332V2.16666H5.83317V2.83332H11.1665V2.16666H12.4998V2.83332H13.8332C14.3855 2.83332 14.8332 3.28104 14.8332 3.83332V13.8333C14.8332 14.3856 14.3855 14.8333 13.8332 14.8333H3.1665C2.61422 14.8333 2.1665 14.3856 2.1665 13.8333V3.83332C2.1665 3.28104 2.61422 2.83332 3.1665 2.83332H4.49984ZM4.49984 4.16666H3.49984V7.16666H13.4998V4.16666H12.4998V4.83332H11.1665V4.16666H5.83317V4.83332H4.49984V4.16666ZM13.4998 8.49999H3.49984V13.5H13.4998V8.49999Z",
    fill: "#347AB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.355dd347d7255ef8186100c5e474383f.svg";
export { ForwardRef as ReactComponent };